import type { IUserRepository } from "@domain/repositories";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";
import type { PagedUserSummaryList, UserSummary } from "@domain/schemas/workspace";

@injectable()
export class UserDirectoryService {
  @inject(TYPES.IUserRepository)
  private _userRepository!: IUserRepository;

  async searchUsersAsync(searchTerm: string, page?: number, pageSize?: number): Promise<PagedUserSummaryList> {
    return this._userRepository.searchUsersAsync(searchTerm, page, pageSize);
  }

  async getUsersByIdsAsync(userIds: string[]): Promise<UserSummary[]> {
    return this._userRepository.getUsersByIdsAsync(userIds);
  }
}
